import React from "react";
import ReactTags from "react-tag-autocomplete";

class ProxySubnetsTags extends React.Component {
    state = {
        tags: [],
        tag_suggestions: this.props.tags
    };

    componentDidMount() {
        this.inputRef = React.createRef();
        let tags = [];
        
        this.props.subnet.tags.forEach(tag => {
            tags.push({id: tag.id, name: tag.tag}); 
        });

        this.setState({tags});
    }

    onDelete(i) {
        const tags = this.state.tags.slice(0);
        tags.splice(i, 1);
        this.setState({ tags }, () => {
            this.props.updateSubnet(this.props.subnet);
        });

        tags.map((tag) => {
            tag.tag = tag.name;
            return tag;
        });

        this.props.toggleCell(this.props.subnet.id, 'tags', tags);
    }

    onAddition(tag) {
        const tags = [].concat(this.state.tags, tag);
        this.setState({ tags }, () => {
            this.props.updateSubnet(this.props.subnet);
        });

        tags.map((tag) => {
            tag.tag = tag.name;
            return tag;
        });
        
        this.props.toggleCell(this.props.subnet.id, 'tags', tags);
    }

    render() {
        return (
            <React.Fragment>
                <form autoComplete="off" className="form form--horizontal" >
                    <ReactTags
                        ref={this.inputRef}
                        tags={this.state.tags}
                        allowNew={true}
                        suggestions={this.state.tag_suggestions}
                        onDelete={this.onDelete.bind(this)}
                        onAddition={this.onAddition.bind(this)} 
                        placeholderText="Add Tag" 
                        addOnBlur={true} 
                    />
                </form>
            </React.Fragment>
        );
    }
}

export default ProxySubnetsTags;
